var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTopic4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 34,
    viewBox: "0 0 60 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.3927 34H17.6952C16.1139 34 14.681 33.0684 14.0393 31.6231L0 0L60 0L46.0524 31.6146C45.4127 33.0644 43.9774 34 42.3927 34Z",
    fill: "#AFF7CD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2634 26V22.112H22.7914V19.448L31.6234 8.96H34.5514V19.088H36.7834V22.112H34.5514V26H31.2634ZM26.8234 19.088H31.2634V13.832L26.8234 19.088Z",
    fill: "#202D66"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopic4);
export default __webpack_public_path__ + "static/media/topic4.b07b6e1b1e3dd884b5c075cca164443b.svg";
export { ForwardRef as ReactComponent };